"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circular = void 0;
var React = __importStar(require("react"));
var styles = __importStar(require("./styles.modules.css"));
var text_1 = require("../text");
var defaultProps = {
    strokeWidth: 20,
};
var Circle = function (props) {
    var radius = props.radius, className = props.className, strokeWidth = props.strokeWidth, percentage = props.percentage;
    var circumference = Math.PI * radius * 2;
    var r = radius - strokeWidth / 2;
    var generatedProps = {
        className: className,
        r: r >= 0 ? r : 0,
        strokeDashoffset: 0,
        fill: "transparent",
        strokeDasharray: circumference,
        cx: radius,
        cy: radius,
        strokeWidth: "".concat(strokeWidth, "px"),
        transform: "rotate(-90, ".concat(radius, ", ").concat(radius, ")"),
    };
    if (percentage) {
        var calculatedPercentage = ((100 - percentage) / 100) * circumference;
        generatedProps.strokeDashoffset = calculatedPercentage;
    }
    return React.createElement("circle", __assign({}, generatedProps));
};
var Circular = /** @class */ (function (_super) {
    __extends(Circular, _super);
    function Circular(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            radius: 0,
        };
        _this.onResize = _this.onResize.bind(_this);
        _this.calculateRadius = _this.calculateRadius.bind(_this);
        return _this;
    }
    Circular.prototype.onResize = function () {
        var radius = this.calculateRadius();
        this.setState({ radius: radius });
    };
    Circular.prototype.calculateRadius = function () {
        return this.element.clientHeight < this.element.clientHeight
            ? this.element.clientHeight
            : this.element.clientWidth;
    };
    Circular.prototype.componentDidMount = function () {
        var radius = this.calculateRadius();
        this.setState({ radius: radius });
        window.addEventListener("resize", this.onResize);
    };
    Circular.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.onResize);
    };
    Circular.prototype.render = function () {
        var _this = this;
        var _a = this.props, percentage = _a.percentage, label = _a.label, strokeWidth = _a.strokeWidth;
        var radius = this.state.radius;
        var pxRadius = radius / 2;
        return (React.createElement("div", { className: styles.circular, ref: function (element) { return (_this.element = element); } },
            React.createElement("div", { className: styles.text },
                React.createElement("div", { className: styles.percentage },
                    percentage,
                    "%"),
                React.createElement(text_1.Text, { className: styles.label }, label)),
            React.createElement("svg", { width: radius, height: radius, xmlns: "http://www.w3.org/2000/svg" },
                React.createElement(Circle, { strokeWidth: strokeWidth, className: styles.background, radius: pxRadius }),
                React.createElement(Circle, { strokeWidth: strokeWidth, className: styles.bar, radius: pxRadius, percentage: percentage }))));
    };
    Circular.defaultProps = defaultProps;
    return Circular;
}(React.Component));
exports.Circular = Circular;
exports.default = Circular;
//# sourceMappingURL=circular.js.map